import { DEFAULT_CURRENCY } from 'components/FeaturedSpreadsheet/constants';
import { UnitsFormatterProps } from './GridFormatter.props';
import { StyledUnitsButton } from './GridFormatter.styles';

const UnitsFormatter = ({ currency, onUnitsChanged, isLoading, label }: UnitsFormatterProps) => {
  const { units = '', symbol } = currency;
  const foreignCurrency = currency?.code !== DEFAULT_CURRENCY;

  return (
    <StyledUnitsButton onClick={onUnitsChanged} disabled={isLoading} $foreignCurrency={foreignCurrency}>
      {label ?? `${symbol} ${units}`}
    </StyledUnitsButton>
  );
};

export default UnitsFormatter;
